import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllClientSchedulingListAction,
  getAllUsersSchedulingListAction,
  resetAllClientScheduleList,
  resetAllClientScheduleTotalCount,
  resetAllusersScheduleList,
  resetAllusersScheduleTotalCount,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../../redux/scheduling";
import { resetSession } from "../../../../redux/auth";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import {
  GetAllClientSchedulingListPayloadType,
  GetAllUsersSchedulingListPayloadType,
} from "../../../../commonTypes/schedulingTypes";
import AllClientsScheduleCalendarView from "../../../../components/Scheduling/ScheduleReports/AllClientsReports/AllClientsScheduleCalendarView";
import AllClientScheduleSorting from "./AllClientsScheduleSorting";
import AllClientScheduleFilter from "../../../../components/Scheduling/ScheduleReports/AllClientsReports/AllClientScheduleFilter";
import { GetClientDirectoryListPayloadType } from "../../../../commonTypes/clientDirectoryTypes";
import { getClientDirectoryListAction } from "../../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../../redux/clientDirectory/clientDirectoryType";
import useDebounce from "../../../../customHooks/useDebounce";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import InternalUsersDropdown from "../../../../components/commons/InternalUsersDropdown/InternalUsersDropdown";

type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  totalCount: number;
  totalClientCount: any;
  allClientScheduleList: any;
  clientDirectoryList: [] | ClientDirectoryListType[];
  clientDirectoryFetching: boolean;
  type?: string;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchResetAllClientScheduleTotalCount: () => void;
  dispatchResetAllClientScheduleList: () => void;
  dispatchGetAllClientSchedulingList: (
    data: GetAllClientSchedulingListPayloadType
  ) => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
};

export type ClientListType = {
  value: number | undefined | null;
  label: string | null;
};

export type InternalUserDropDownType = {
  value: number | null;
  label: string | null;
};

const AllClientsSchedule = ({
  token,
  fetching,
  message,
  error,
  type,
  statusCode,
  success,
  totalCount,
  totalClientCount,
  allClientScheduleList,
  clientDirectoryList,
  clientDirectoryFetching,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchGetAllClientSchedulingList,
  dispatchResetAllClientScheduleTotalCount,
  dispatchResetAllClientScheduleList,
  dispatchGetClientDirectoryListAction,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [sortByClientName, setSortByClientName] = useState({
    name: "Recently Added First",
    value: "",
  });
  const [sortByClientCode, setSortByClientCode] = useState({
    name: "Recently Added First",
    value: "",
  });
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [finalClientList, setFinalClientList] = useState<ClientListType[] | []>(
    []
  );
  const [clientSelected, setClientSelected] = useState<ClientListType>({
    value: null,
    label: "Select Client...",
  });
  const [showData, setShowData] = useState(false);
  const [filter, setFilter] = useState<number | null | undefined>(null);
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [finalcalendarData, setFinalcalendarData] = useState<any>([]);
  const [internalUserSelected, setInternalUserSelected] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);

  useEffect(() => {
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetAllClientScheduleTotalCount();
    dispatchResetAllClientScheduleList();
  }, []);

  useEffect(() => {
    if (token && totalClientCount) {
      if (offset <= +totalClientCount) {
        const finalData = {
          token,
          status: 1,
          offset,
          limit,
          searchValue: text,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [offset]);

  const fetchNewData = () => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
        status: 1,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };

  useDebounce(
    () => {
      fetchNewData();
    },
    500,
    [text]
  );

  useEffect(() => {
    if (clientDirectoryList?.length) {
      if (offset <= +totalClientCount) {
        let finalClientData = clientDirectoryList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    dispatchResetAllClientScheduleList();
    if (token && displayStartDate && displayEndDate) {
      let finalData = {
        token,
        clientName: sortByClientName?.value,
        clientCode: sortByClientCode?.value,
        filterClientCode: clientSelected?.value,
        userId: internalUserSelected?.value,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
      };
      dispatchGetAllClientSchedulingList(finalData);
    }
  }, [sortByClientName?.name, sortByClientCode?.name]);
  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };

  const onMenuClose = () => setLoadCondition(true);
  const handleFilter = (type?: string) => {
    if (type != "clear") {
      setFilter(clientSelected?.value);
    }

    if (token) {
      let finalData = {
        token,
        clientName: sortByClientName?.value,
        clientCode: sortByClientCode?.value,
        filterClientCode: type === "clear" ? null : clientSelected?.value,
        userId: internalUserSelected?.value,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
      };
      dispatchGetAllClientSchedulingList(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }

    return false;
  };

  const handleSubmit = () => {
    setSortByClientCode({
      name: "Recently Added First",
      value: "",
    });
    setSortByClientName({
      name: "Recently Added First",
      value: "",
    });
    setClientSelected({
      value: null,
      label: "Select..",
    });
    handleChangeClient("");
    setShowData(true);
    setFilter(null);
    dispatchResetAllClientScheduleList();
    if (token && internalUserSelected?.value) {
      let finalData = {
        token,
        userId: internalUserSelected?.value,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
      };
      dispatchGetAllClientSchedulingList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }

    if (token) {
      let finalData = {
        token,
        userId: internalUserSelected?.value,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
      };
      dispatchGetAllClientSchedulingList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title={
            type?.length
              ? "Manager-Client Scheduling"
              : `All Clients Scheduling`
          }
        />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">
                {type?.length
                  ? "Manager-Client Scheduling List"
                  : "All Clients Scheduling List"}
                {!showData ? (
                  <></>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } ${type?.length ? "record" : "entries"} found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex">
              <div className="ml-2">
                <AllClientScheduleSorting
                  setSortByClientName={setSortByClientName}
                  sortByClientName={sortByClientName}
                  setSortByClientCode={setSortByClientCode}
                  sortByClientCode={sortByClientCode}
                />
              </div>

              <div className="ml-2">
                <AllClientScheduleFilter
                  clientSelected={clientSelected}
                  finalClientList={finalClientList}
                  handleChangeClient={handleChangeClient}
                  checkBottom={checkBottom}
                  clientDirectoryFetching={clientDirectoryFetching}
                  onMenuClose={onMenuClose}
                  setText={setText}
                  setOffset={setOffset}
                  loadCondition={loadCondition}
                  setLoadCondition={setLoadCondition}
                  handleFilter={handleFilter}
                  setClientSelected={setClientSelected}
                  filter={filter}
                  setFilter={setFilter}
                />
              </div>
            </div>
          </div>
          <div className="d-flex">
            {type?.length && (
              <div className="col-md-3 p-0 mt-2 mb-4 ml-3">
                <InternalUsersDropdown
                  internalUserSelected={internalUserSelected}
                  setInternalUserSelected={setInternalUserSelected}
                />
              </div>
            )}
            <div
              className={
                type?.length ? "form-group ml-3 mt-2" : "form-group ml-3 mt-1"
              }
            >
              <label className="mb-1">Date</label>
              <div>
                <ReportsDateSelect
                  setToggle={setToggle}
                  toggle={toggle}
                  startDate={startDate ? startDate : ""}
                  endDate={endDate ? endDate : ""}
                  handleStartDateChange={handleStartDateChange}
                  handleEndDateChange={handleEndDateChange}
                  type={"schedulingReport"}
                />
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-center">
              <button
                className="btn btn-primary pl-3 pb-2"
                style={{ marginTop: type?.length ? "11px" : "17px" }}
                disabled={
                  type?.length
                    ? !internalUserSelected?.value ||
                      !startDate?.length ||
                      !endDate?.length
                    : !startDate?.length || !endDate?.length
                }
                onClick={handleSubmit}
              >
                Apply
              </button>
            </div>
          </div>
          {!showData ? (
            type && type?.length ? (
              <div className="mt-5">
                <EmptyListPage
                  title="No Manager-Client Schedule List Found!"
                  text="Please Select User To See Manager-Client Scheduling!"
                  imageWidth="30%"
                />
              </div>
            ) : (
              <div className="mt-5">
                <EmptyListPage title="No schedule found" imageWidth="30%" />
              </div>
            )
          ) : (
            <div>
              <AllClientsScheduleCalendarView
                data={allClientScheduleList}
                fetching={fetching}
                filter={filter}
                type={type}
                finalcalendarData={finalcalendarData}
                setFinalcalendarData={setFinalcalendarData}
                internalUserSelected={internalUserSelected}
                totalCount={totalCount ? totalCount : 0}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
              />
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  fetching: state.scheduling.fetching,
  allClientScheduleList: state.scheduling.allClientScheduleList,
  totalCount: state.scheduling.allClientScheduleTotalCount,
  totalClientCount: state.clientDirectory.totalCount,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  clientDirectoryFetching: state.clientDirectory.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchResetAllClientScheduleList: () =>
    dispatch(resetAllClientScheduleList()),
  dispatchResetAllClientScheduleTotalCount: () =>
    dispatch(resetAllClientScheduleTotalCount()),
  dispatchGetAllClientSchedulingList: (
    data: GetAllClientSchedulingListPayloadType
  ) => dispatch(getAllClientSchedulingListAction(data)),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllClientsSchedule);
